/* jshint esversion: 8 */
/* jshint node: true */


import React, { useEffect } from "react";
import "./ContactUsPage.scss";
import SecondaryPageContainer from "components/SecondaryPageContainer/SecondaryPageContainer";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectTheme } from "stateMgmt/appSlice";
import { updateFooterLink } from "stateMgmt/daaSlice";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import ReactGA from "react-ga4";
import logger from "services/LoggingService";

const ContactUsPage = (props) => {
  const dispatch = useDispatch();
  const theme = useSelector(selectTheme);

  ReactGA.send({
    hitType: "pageview",
    page: "/components/MainContentArea/ContactUsPage/ContactUsPage.js",
    title: "ContactUs",
  });

  useEffect(() => {
    document.getElementById("ContactUs_page-top").focus();
  }, []);

  const leavePage = () => {
    logger.debug("  leaving disclaimer page");
    dispatch(updateFooterLink({ calllingLink: "Contact" }));
  };

  const pageContents = (
    <div
      className="row"
      id="ContactUs_page-top"
      data-testid="ContactUs_Page"
      tabIndex={0}
    >
      <div className="col-lg-3" role="note" tabIndex={0}>
        <Typography variant="h3">
          Stay Connected <br></br> with PEPFAR
        </Typography>
        <ul className="c-social__list" role="navigation">
          <li className="c-social__item ">
            <a
              style={{ color: theme.linkColor, fontWeight: 800 }}
              className="c-social__link"
              href="http://www.facebook.com/PEPFAR"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="facebook"
            >
              <i className="fab fa-facebook-square"></i>
            </a>
          </li>
          <li className="c-social__item ">
            <a
              style={{ color: theme.linkColor, fontWeight: 800 }}
              className="c-social__link"
              href="http://www.flickr.com/photos/pepfar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="flickr"
            >
              <i className="fab fa-flickr"></i>
            </a>
          </li>
          <li className="c-social__item ">
            <a
              style={{ color: theme.linkColor, fontWeight: 800 }}
              className="c-social__link"
              href="http://www.youtube.com/user/uspepfar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="youtube"
            >
              <i className="fab fa-youtube-square"></i>
            </a>
          </li>
          <li className="c-social__item ">
            <a
              style={{ color: theme.linkColor, fontWeight: 800 }}
              className="c-social__link"
              href="https://service.govdelivery.com/accounts/USSTATEBPA/subscriber/new?topic_id=USSTATEBPA_24"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="email"
            >
              <i className="fas fa-envelope-square"></i>
            </a>
          </li>
        </ul>
      </div>

      <div className="col-lg-7">
        <div role="note" tabIndex={0}>
          <h1>Contact Us</h1>
          
          <p>
            For information about PEPFAR in general, please visit{" "}
            <a
              style={{ color: theme.linkColor, fontWeight: 800 }}
              href="https://www.state.gov/pepfar/"
              className="link"
              target="_blank"
              rel="noopener noreferrer"
            >
              state.gov/PEPFAR
            </a>.

            To view other U.S. foreign assistance data, please continue{" "}
            <a
              style={{ color: theme.linkColor, fontWeight: 800 }}
              href="http://www.foreignassistance.gov"
              target="_blank"
              rel="noopener noreferrer"
              className="link"
              aria-label="foreign assistance site"
            >
              here
            </a>
            .
          </p>
        </div>

        <form name="dummy-form-for-onblur">
          <p role="note" tabIndex={0}>
            For questions about the federal government not related to PEPFAR,
            visit{" "}
            <a
              style={{ color: theme.linkColor, fontWeight: 800 }}
              href="http://www.usa.gov"
              className="link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Federal governement site"
              tabIndex={0}
              onBlur={() => leavePage()}
            >
              USA.gov
            </a>{" "}
            or call 1(800) FED INFO (1-800-333-4636) (8am - 8pm ET Monday -
            Friday).
          </p>
        </form>
      </div>
    </div>
  );

  return (
    <SecondaryPageContainer
      contents={pageContents}
      showToc={false}
      pageHeaderId="ContactUs_page-top"
      isSidebarCollapsed={props.isSidebarCollapsed}
    />
  );
};

ContactUsPage.propTypes = {
  isSidebarCollapsed: PropTypes.bool.isRequired,
};

export default ContactUsPage;
